// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   CONTAINER PRINCIPAL DO ARQUIVO
   ======================================== */
.file-wrapper {
  position: relative;
  display: inline-block;
}

/* ========================================
   TÍTULO DO ARQUIVO (BOTÃO CLICÁVEL)
   ======================================== */
.file-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px;
  font-size: var(--app-font-size-15px);
  font-weight: var(--app-font-weight-bold);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
  max-width: 150px; /* Ajuste conforme necessário */
}

/* Truncar apenas o texto do título */
.file-title-text {
  max-width: 8ch; /* 8 caracteres */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}



/* ========================================
   ÍCONE DE STATUS AO LADO DO TÍTULO
   ======================================== */
.status-icon {
  font-size: var(--app-font-size-16px);
  margin-left: 4px;
  transition: all 0.2s ease;
}

/* Status NULL/Pendente - Cinza */
.status-null {
  color: var(--app-file-unvalidated);
}

/* Status VALIDADO - Verde */
.status-validado {
  color: var(--app-file-valid);
}

/* Status NÃO VALIDADO - Vermelho */
.status-nao-validado {
  color: var(--app-file-invalid);
}


/* ========================================
   CAIXA DE HOVER (CONTAINER EXTERNO)
   ======================================== */
.hover-box {
  position: absolute;
  bottom: calc(100% + 1px);
  left: 0;
  z-index: 2000;
  /* Garantir que o hover funcione suavemente */
  pointer-events: auto;
}

/* ========================================
   CONTEÚDO DO HOVER (CAIXA BRANCA)
   ======================================== */
.hover-content {
  position: relative;
  background: var(--app-white);
  border-radius: 6px;
  border: 1px solid var(--app-file-menu-border);
  padding: 8px 10px;
  min-width: 180px;
  box-shadow: 0 3px 10px var(--app-ink-alpha-120);
  animation: fadeIn 0.12s ease-out;
}

/* ========================================
   ETAPA 1 - TÍTULO COMPLETO + SETA
   ======================================== */
.hover-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.file-full-title {
  font-size: var(--app-font-size-13px);
  font-weight: var(--app-font-weight-semibold);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
  color: var(--app-legacy-shortcut-text);
}

/* ========================================
   ÍCONE DA SETA (INDICADOR)
   ======================================== */
.hover-indicator {
  font-size: var(--app-font-size-20px);
  color: var(--app-file-muted);
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  /* Garantir que não encolha */
  min-width: 28px;
  text-align: center;
}

.hover-indicator:hover {
  background: var(--app-file-menu-hover);
  color: var(--app-legacy-shortcut-text);
}

.hover-indicator:active {
  background: var(--app-file-dark-text);
}

/* ========================================
   ETAPA 2 - MENU DE STATUS (LATERAL)
   ======================================== */
.hover-menu {
  /* Posicionamento absoluto para ficar ao lado */
  position: absolute;
  top: 0;
  left: calc(100% + 4px);
  
  /* Layout interno */
  display: flex;
  flex-direction: column;
  gap: 6px;
  
  /* Estilo visual */
  background: var(--app-white);
  border-radius: 6px;
  border: 1px solid var(--app-file-menu-border);
  padding: 8px 10px;
  min-width: 160px;
  box-shadow: 0 3px 10px var(--app-ink-alpha-120);
  
  /* Animação de entrada */
  animation: slideInRight 0.15s ease-out;
  
  /* Evitar quebra de linha */
  white-space: nowrap;
  
  /* Garantir que fique acima de outros elementos */
  z-index: 2001;
}

/* ========================================
   OPÇÕES DO MENU
   ======================================== */
.opt {
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.15s ease;
  font-size: var(--app-font-size-13px);
  font-weight: var(--app-font-weight-medium);
  -webkit-user-select: none;
          user-select: none;
  color: var(--app-legacy-shortcut-text);
}

.opt:hover {
  background: var(--app-file-menu-surface);
}

.opt:active {
  background: var(--app-file-menu-focus);
}

/* Desabilitar durante loading (opcional) */
.opt.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.opt i {
  font-size: var(--app-font-size-18px);
  flex-shrink: 0;
}

/* ========================================
   CORES DOS STATUS
   ======================================== */
.text-validado {
  color: var(--app-file-valid);
}

.text-nao-validado {
  color: var(--app-file-invalid);
}

.text-pendente {
  color: var(--app-file-unvalidated);
}

/* ========================================
   ANIMAÇÕES
   ======================================== */
@keyframes fadeIn {
  from { 
    opacity: 0; 
    transform: translateY(-4px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

@keyframes slideInRight {
  from { 
    opacity: 0; 
    transform: translateX(-8px); 
  }
  to { 
    opacity: 1; 
    transform: translateX(0); 
  }
}

/* ========================================
   RESPONSIVO - TABLETS
   ======================================== */
@media (max-width: 768px) {
  .hover-box {
    /* Em tablets, ajustar posição se necessário */
    max-width: calc(100vw - 40px);
  }
  
  .hover-content {
    min-width: 160px;
  }
  
  .hover-menu {
    min-width: 140px;
  }
  
  .file-full-title {
    max-width: 140px;
  }
}

/* ========================================
   RESPONSIVO - MOBILE
   ======================================== */
@media (max-width: 640px) {
  .hover-box {
    /* Em mobile, o menu pode ficar abaixo ao invés de ao lado */
    max-width: calc(100vw - 20px);
  }
  
  .hover-content {
    min-width: 200px;
  }
  
  .hover-menu {
    /* Menu abaixo ao invés de ao lado */
    position: relative;
    left: 0;
    top: auto;
    margin-top: 8px;
    width: 100%;
    animation: slideInDown 0.15s ease-out;
  }
  
  .file-full-title {
    max-width: 160px;
  }
}

/* Animação para mobile (de cima para baixo) */
@keyframes slideInDown {
  from { 
    opacity: 0; 
    transform: translateY(-8px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

/* ========================================
   TOUCH DEVICES (MELHOR USABILIDADE)
   ======================================== */
@media (hover: none) and (pointer: coarse) {
  /* Aumentar área de toque */
  .hover-indicator {
    padding: 8px;
    min-width: 36px;
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .opt {
    padding: 12px;
    min-height: 44px;
  }
  
  /* Adicionar feedback visual de toque */
  .opt:active {
    background: var(--app-file-dark-text);
  }
  
  .hover-indicator:active {
    background: var(--app-file-dark-text);
  }
}

/* ========================================
   MODO ESCURO (OPCIONAL)
   ======================================== */
@media (prefers-color-scheme: dark) {
  .hover-content,
  .hover-menu {
    background: var(--app-file-dark-surface);
    border-color: var(--app-file-dark-border);
    box-shadow: 0 3px 10px var(--app-ink-alpha-300);
  }
  
  .file-full-title,
  .opt {
    color: var(--app-file-dark-text);
  }
  
  .hover-indicator {
    color: var(--app-file-dark-muted);
  }
  
  .hover-indicator:hover {
    background: var(--app-file-dark-hover);
    color: var(--app-white);
  }
  
  .opt:hover {
    background: var(--app-file-dark-hover);
  }
  
  .opt:active {
    background: var(--app-file-dark-active);
  }
}

/* ========================================
   AJUSTES FINOS DE PERFORMANCE
   ======================================== */
.hover-box,
.hover-menu {
  /* Forçar aceleração por hardware */
  will-change: transform, opacity;
  backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;
}

/* Remover will-change após animação para economizar recursos */
.hover-box.animated,
.hover-menu.animated {
  will-change: auto;
}

/* ========================================
   ACESSIBILIDADE
   ======================================== */
/* Focus visível para navegação por teclado */
.hover-indicator:focus-visible,
.opt:focus-visible {
  outline: 2px solid var(--app-file-menu-accent);
  outline-offset: 2px;
}

/* Melhorar contraste em modo de alto contraste */
@media (prefers-contrast: high) {
  .hover-content,
  .hover-menu {
    border-width: 2px;
  }
  
  .opt:hover {
    background: var(--app-file-dark-text);
    border: 1px solid var(--app-file-muted);
  }
}

/* Respeitar preferência de movimento reduzido */
@media (prefers-reduced-motion: reduce) {
  .hover-box,
  .hover-menu,
  .hover-indicator,
  .opt {
    animation: none;
    transition: none;
  }
}
.file-title { color: var(--app-primary); }
.file-link-icon { font-size: var(--app-font-size-menu); }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/file-download-link/file-download-link.component.css"],"names":[],"mappings":"AAAA;;6CAE6C;AAC7C;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;6CAE6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,wCAAwC;EACxC,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA,qCAAqC;AACrC;EACE,cAAc,EAAE,iBAAiB;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;;;AAIA;;6CAE6C;AAC7C;EACE,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,kCAAkC;AACpC;;AAEA,4BAA4B;AAC5B;EACE,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;AAChC;;;AAGA;;6CAE6C;AAC7C;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,aAAa;EACb,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;;6CAE6C;AAC7C;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,OAAO;EACP,YAAY;EACZ,sCAAsC;AACxC;;AAEA;;6CAE6C;AAC7C;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;6CAE6C;AAC7C;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,MAAM;EACN,sBAAsB;;EAEtB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;;EAE/C,wBAAwB;EACxB,sCAAsC;;EAEtC,2BAA2B;EAC3B,mBAAmB;;EAEnB,iDAAiD;EACjD,aAAa;AACf;;AAEA;;6CAE6C;AAC7C;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;EACpC,0CAA0C;EAC1C,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;6CAE6C;AAC7C;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;6CAE6C;AAC7C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;6CAE6C;AAC7C;EACE;IACE,8CAA8C;IAC9C,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;6CAE6C;AAC7C;EACE;IACE,4DAA4D;IAC5D,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,eAAe;IACf,WAAW;IACX,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;6CAE6C;AAC7C;EACE,2BAA2B;EAC3B;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA,uCAAuC;EACvC;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;;6CAE6C;AAC7C;EACE;;IAEE,wCAAwC;IACxC,yCAAyC;IACzC,+CAA+C;EACjD;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;IACtC,uBAAuB;EACzB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;;6CAE6C;AAC7C;;EAEE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,+DAA+D;AAC/D;;EAEE,iBAAiB;AACnB;;AAEA;;6CAE6C;AAC7C,6CAA6C;AAC7C;;EAEE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE;;IAEE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,uCAAuC;EACzC;AACF;;AAEA,gDAAgD;AAChD;EACE;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA,cAAc,yBAAyB,EAAE;AACzC,kBAAkB,oCAAoC,EAAE","sourcesContent":["/* ========================================\n   CONTAINER PRINCIPAL DO ARQUIVO\n   ======================================== */\n.file-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n/* ========================================\n   TÍTULO DO ARQUIVO (BOTÃO CLICÁVEL)\n   ======================================== */\n.file-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px;\n  font-size: var(--app-font-size-15px);\n  font-weight: var(--app-font-weight-bold);\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  max-width: 150px; /* Ajuste conforme necessário */\n}\n\n/* Truncar apenas o texto do título */\n.file-title-text {\n  max-width: 8ch; /* 8 caracteres */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n}\n\n\n\n/* ========================================\n   ÍCONE DE STATUS AO LADO DO TÍTULO\n   ======================================== */\n.status-icon {\n  font-size: var(--app-font-size-16px);\n  margin-left: 4px;\n  transition: all 0.2s ease;\n}\n\n/* Status NULL/Pendente - Cinza */\n.status-null {\n  color: var(--app-file-unvalidated);\n}\n\n/* Status VALIDADO - Verde */\n.status-validado {\n  color: var(--app-file-valid);\n}\n\n/* Status NÃO VALIDADO - Vermelho */\n.status-nao-validado {\n  color: var(--app-file-invalid);\n}\n\n\n/* ========================================\n   CAIXA DE HOVER (CONTAINER EXTERNO)\n   ======================================== */\n.hover-box {\n  position: absolute;\n  bottom: calc(100% + 1px);\n  left: 0;\n  z-index: 2000;\n  /* Garantir que o hover funcione suavemente */\n  pointer-events: auto;\n}\n\n/* ========================================\n   CONTEÚDO DO HOVER (CAIXA BRANCA)\n   ======================================== */\n.hover-content {\n  position: relative;\n  background: var(--app-white);\n  border-radius: 6px;\n  border: 1px solid var(--app-file-menu-border);\n  padding: 8px 10px;\n  min-width: 180px;\n  box-shadow: 0 3px 10px var(--app-ink-alpha-120);\n  animation: fadeIn 0.12s ease-out;\n}\n\n/* ========================================\n   ETAPA 1 - TÍTULO COMPLETO + SETA\n   ======================================== */\n.hover-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.file-full-title {\n  font-size: var(--app-font-size-13px);\n  font-weight: var(--app-font-weight-semibold);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n  color: var(--app-legacy-shortcut-text);\n}\n\n/* ========================================\n   ÍCONE DA SETA (INDICADOR)\n   ======================================== */\n.hover-indicator {\n  font-size: var(--app-font-size-20px);\n  color: var(--app-file-muted);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  /* Garantir que não encolha */\n  min-width: 28px;\n  text-align: center;\n}\n\n.hover-indicator:hover {\n  background: var(--app-file-menu-hover);\n  color: var(--app-legacy-shortcut-text);\n}\n\n.hover-indicator:active {\n  background: var(--app-file-dark-text);\n}\n\n/* ========================================\n   ETAPA 2 - MENU DE STATUS (LATERAL)\n   ======================================== */\n.hover-menu {\n  /* Posicionamento absoluto para ficar ao lado */\n  position: absolute;\n  top: 0;\n  left: calc(100% + 4px);\n  \n  /* Layout interno */\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  \n  /* Estilo visual */\n  background: var(--app-white);\n  border-radius: 6px;\n  border: 1px solid var(--app-file-menu-border);\n  padding: 8px 10px;\n  min-width: 160px;\n  box-shadow: 0 3px 10px var(--app-ink-alpha-120);\n  \n  /* Animação de entrada */\n  animation: slideInRight 0.15s ease-out;\n  \n  /* Evitar quebra de linha */\n  white-space: nowrap;\n  \n  /* Garantir que fique acima de outros elementos */\n  z-index: 2001;\n}\n\n/* ========================================\n   OPÇÕES DO MENU\n   ======================================== */\n.opt {\n  padding: 8px 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: background 0.15s ease;\n  font-size: var(--app-font-size-13px);\n  font-weight: var(--app-font-weight-medium);\n  user-select: none;\n  color: var(--app-legacy-shortcut-text);\n}\n\n.opt:hover {\n  background: var(--app-file-menu-surface);\n}\n\n.opt:active {\n  background: var(--app-file-menu-focus);\n}\n\n/* Desabilitar durante loading (opcional) */\n.opt.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.opt i {\n  font-size: var(--app-font-size-18px);\n  flex-shrink: 0;\n}\n\n/* ========================================\n   CORES DOS STATUS\n   ======================================== */\n.text-validado {\n  color: var(--app-file-valid);\n}\n\n.text-nao-validado {\n  color: var(--app-file-invalid);\n}\n\n.text-pendente {\n  color: var(--app-file-unvalidated);\n}\n\n/* ========================================\n   ANIMAÇÕES\n   ======================================== */\n@keyframes fadeIn {\n  from { \n    opacity: 0; \n    transform: translateY(-4px); \n  }\n  to { \n    opacity: 1; \n    transform: translateY(0); \n  }\n}\n\n@keyframes slideInRight {\n  from { \n    opacity: 0; \n    transform: translateX(-8px); \n  }\n  to { \n    opacity: 1; \n    transform: translateX(0); \n  }\n}\n\n/* ========================================\n   RESPONSIVO - TABLETS\n   ======================================== */\n@media (max-width: 768px) {\n  .hover-box {\n    /* Em tablets, ajustar posição se necessário */\n    max-width: calc(100vw - 40px);\n  }\n  \n  .hover-content {\n    min-width: 160px;\n  }\n  \n  .hover-menu {\n    min-width: 140px;\n  }\n  \n  .file-full-title {\n    max-width: 140px;\n  }\n}\n\n/* ========================================\n   RESPONSIVO - MOBILE\n   ======================================== */\n@media (max-width: 640px) {\n  .hover-box {\n    /* Em mobile, o menu pode ficar abaixo ao invés de ao lado */\n    max-width: calc(100vw - 20px);\n  }\n  \n  .hover-content {\n    min-width: 200px;\n  }\n  \n  .hover-menu {\n    /* Menu abaixo ao invés de ao lado */\n    position: relative;\n    left: 0;\n    top: auto;\n    margin-top: 8px;\n    width: 100%;\n    animation: slideInDown 0.15s ease-out;\n  }\n  \n  .file-full-title {\n    max-width: 160px;\n  }\n}\n\n/* Animação para mobile (de cima para baixo) */\n@keyframes slideInDown {\n  from { \n    opacity: 0; \n    transform: translateY(-8px); \n  }\n  to { \n    opacity: 1; \n    transform: translateY(0); \n  }\n}\n\n/* ========================================\n   TOUCH DEVICES (MELHOR USABILIDADE)\n   ======================================== */\n@media (hover: none) and (pointer: coarse) {\n  /* Aumentar área de toque */\n  .hover-indicator {\n    padding: 8px;\n    min-width: 36px;\n    min-height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .opt {\n    padding: 12px;\n    min-height: 44px;\n  }\n  \n  /* Adicionar feedback visual de toque */\n  .opt:active {\n    background: var(--app-file-dark-text);\n  }\n  \n  .hover-indicator:active {\n    background: var(--app-file-dark-text);\n  }\n}\n\n/* ========================================\n   MODO ESCURO (OPCIONAL)\n   ======================================== */\n@media (prefers-color-scheme: dark) {\n  .hover-content,\n  .hover-menu {\n    background: var(--app-file-dark-surface);\n    border-color: var(--app-file-dark-border);\n    box-shadow: 0 3px 10px var(--app-ink-alpha-300);\n  }\n  \n  .file-full-title,\n  .opt {\n    color: var(--app-file-dark-text);\n  }\n  \n  .hover-indicator {\n    color: var(--app-file-dark-muted);\n  }\n  \n  .hover-indicator:hover {\n    background: var(--app-file-dark-hover);\n    color: var(--app-white);\n  }\n  \n  .opt:hover {\n    background: var(--app-file-dark-hover);\n  }\n  \n  .opt:active {\n    background: var(--app-file-dark-active);\n  }\n}\n\n/* ========================================\n   AJUSTES FINOS DE PERFORMANCE\n   ======================================== */\n.hover-box,\n.hover-menu {\n  /* Forçar aceleração por hardware */\n  will-change: transform, opacity;\n  backface-visibility: hidden;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Remover will-change após animação para economizar recursos */\n.hover-box.animated,\n.hover-menu.animated {\n  will-change: auto;\n}\n\n/* ========================================\n   ACESSIBILIDADE\n   ======================================== */\n/* Focus visível para navegação por teclado */\n.hover-indicator:focus-visible,\n.opt:focus-visible {\n  outline: 2px solid var(--app-file-menu-accent);\n  outline-offset: 2px;\n}\n\n/* Melhorar contraste em modo de alto contraste */\n@media (prefers-contrast: high) {\n  .hover-content,\n  .hover-menu {\n    border-width: 2px;\n  }\n  \n  .opt:hover {\n    background: var(--app-file-dark-text);\n    border: 1px solid var(--app-file-muted);\n  }\n}\n\n/* Respeitar preferência de movimento reduzido */\n@media (prefers-reduced-motion: reduce) {\n  .hover-box,\n  .hover-menu,\n  .hover-indicator,\n  .opt {\n    animation: none;\n    transition: none;\n  }\n}\n.file-title { color: var(--app-primary); }\n.file-link-icon { font-size: var(--app-font-size-menu); }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
